import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var VideoInterviewRoutes = {
    "/video-interview/questions-list": {
        "loginRequired": true,
        "name": "appLayout.harriSH.video-interview-questions",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewQuestionsBankController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.video-interview-questions');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
         }]
    },
    "/video-interview/templates-list": {
        "loginRequired": true,
        "name": "appLayout.harriSH.video-interview-templates",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewQuestionsTemplatesController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.video-interview-templates');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
    "/video-interview/questions/{questionId:[0-9]*}": {
        "loginRequired": true,
        "name": "appLayout.harriSH.video-interview-question",
        "params": {"questionId": ""},
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewQuestionController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.video-interview-question');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
    "/video-interview/templates/{templateId:[0-9]*}/{duplicateTemplate:bool}": {
        "loginRequired": true,
        "name": "appLayout.harriSH.video-interview-template",
        "params": {"templateId": "", "duplicateTemplate": false},
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewTemplateController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.video-interview-template');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
    "/video-interview/types": {
        "loginRequired": true,
        "name": "appLayout.harriSH.video-interview-types",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "questionsBankTypesController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.video-interview-types');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
    "/video-interview/media": {
        "loginRequired": true,
        "name": "appLayout.harriSH.video-interview-media",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "videoInterviewMediaController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.video-interview-media');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },

    [`/video-interview/questions-list/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.video-interview-questions",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewQuestionsBankController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.access-portal.video-interview-questions');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
    [`/video-interview/templates-list/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.video-interview-templates",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewQuestionsTemplatesController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.access-portal.video-interview-templates');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
    [`/video-interview/questions/new/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.video-interview-question-new",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewQuestionController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                $state.go(interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.access-portal.video-interview-question-new'), {reload: true});
            }]
    },
    [`/video-interview/questions/{questionId:[0-9]*}/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.video-interview-question-edit",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewQuestionController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.access-portal.video-interview-question-new');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
    [`/video-interview/templates/new/${hmapPathParamRegex}?duplicateTemplate`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.video-interview-template-new",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewTemplateController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.access-portal.video-interview-template-new');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
        }]
    },
    [`/video-interview/templates/{templateId:[0-9]*}/${hmapPathParamRegex}?duplicateTemplate`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.video-interview-template-edit",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "interviewTemplateController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.access-portal.video-interview-template-new');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
        }]
    },
    [`/video-interview/types/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.video-interview-types",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "questionsBankTypesController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.access-portal.video-interview-types');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
    [`/video-interview/media/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.video-interview-media",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screening Questions"
            }
        ],
        "component": "videoInterviewMediaController",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW);
                const state = interviewBankDataService.checkPermissionsAndSettings(hUser.getActiveBrandIdWithAccess(), 'appLayout.harriSH.access-portal.video-interview-media');
                if (state.redirectToWorkspace) {
                    Utils.redirectToWorkspace(state.state)
                }
                else {
                    $state.go(state.state, {reload: true});
                }
            }]
    },
};